import { gql } from "@apollo/client";

export const GET_ALL_SOCIAL_MEDIA_LINKS = gql`
query getAllMedia {
  allMedia {
    nodes {
      mId
      mediaLink
      mediaName
      createdAt
      deletedAt
      updatedAt
    }
  }
}
`
